<template>
  <contacts-template />
</template>

<script>
import ContactsTemplate from "@/app/contacts/components/templates/ContactsTemplate.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    ContactsTemplate,
  },
});
</script>
